import { jsx } from "react/jsx-runtime";
import styled from "@mui/material/styles/styled";
import MTypography from "@mui/material/Typography";
import get from "lodash/get";
import { filterValidProps, isHexColor, isSystemColorValue } from "../../shared/helpers";
import { useParentBg, isColorName } from "../../shared/hooks/current-color";
import { useTheme } from "../ThemeProvider";
const CustomTypography = styled(MTypography)(({ theme, sx, allowHexColor, color: propsColor }) => {
  const { palette } = useTheme();
  const parentBg = useParentBg();
  let [rawBg, rawColor] = propsColor?.split(".") ?? [];
  let color;
  if (isColorName(rawBg)) {
    rawColor = rawBg;
    rawBg = void 0;
  }
  if (isHexColor(rawBg)) {
    if (allowHexColor) {
      rawColor = rawBg;
      rawBg = void 0;
    } else {
      rawColor = void 0;
      rawBg = void 0;
      console.error(`Typography: incompatible color prop provided ${propsColor}, please provide DionColorType`);
    }
  }
  const bg = rawBg ?? parentBg;
  try {
    if (isSystemColorValue(rawBg)) {
      color = rawBg;
    } else {
      color = rawColor ? get(palette, [bg, rawColor], "currentColor") : "currentColor";
    }
  } catch (err) {
    console.error("Typography:", { propsColor, err });
  }
  return { ...sx, color };
});
const Typography = ({ sx, ...props }) => {
  const newSx = filterValidProps(sx || {});
  return /* @__PURE__ */ jsx(CustomTypography, { sx: newSx, ...props });
};
var Typography_default = Typography;
export {
  Typography_default as default
};
